import React, { useEffect, useState } from "react";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { aiChatPDF } from "../../api/index.js";
import { toast } from "react-toastify";
import {
  formatDateTime,
} from "../../utils/helper.jsx";
import { SafeHtml } from "../../components/SafeHtml";

function AssetList() {
  const [waitingReply, setWaitingReply] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  async function getData() {
    try {
      setLoading(true);
      const queryParam = {};
      const res = await aiChatPDF.getChat(queryParam);
      if (res.ok) {
        const body = await res.json();
        if (body.data) {
          setMessages(body.data);
        } else {
          setMessages([]);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  const sendMessage = async () => {
    if (!input.trim()) {
      toast.error("Please enter a message");
      return;
    }
    setWaitingReply(true);
    const newMessage = {
      role: "user",
      message: input,
      createdAt: new Date().toISOString(),
    };
    setMessages((prevMessages) => [...prevMessages, newMessage]);
    try {
      const sendInput = input;
      setInput("");
      const res = await aiChatPDF.sendChatMessage({
        message: sendInput,
      });

      if (res.ok) {
        const body = await res.json();
        const reply = {
          role: "assistant",
          message: body.data?.message,
          createdAt: new Date().toISOString(),
        };
        setMessages((prevMessages) => [...prevMessages, reply]);
      } else {
        const body = await res.json();
        toast.error(body.message || "Failed to send message");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while sending the message");
    } finally {
      setWaitingReply(false);
    }
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") sendMessage();
  };
  return (
    <div className="row justify-content-center">
      <div className="col-xl-12">
        <ul className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#/">Document Chat</a>
          </li>
          <li className="breadcrumb-item active">Document Chat</li>
        </ul>

        <h1 className="page-header">Document Chat</h1>

        <hr className="mb-4" />
        <div style={{ padding: "10px" }}>
          <style>
            {`
            .feedback-btn {
              transition: all 0.2s ease;
              border-radius: 4px;
            }
            .feedback-btn:hover {
              transform: scale(1.1);
            }
            .feedback-btn.active {
              box-shadow: 0 0 0 2px rgba(0,0,0,0.1);
            }
            .reason-input-container {
              animation: slideDown 0.3s ease-out;
            }
            @keyframes slideDown {
              from {
                opacity: 0;
                transform: translateY(-10px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
            .feedback-modal {
              animation: fadeIn 0.3s ease-out;
            }
            @keyframes fadeIn {
              from {
                opacity: 0;
              }
              to {
                opacity: 1;
              }
            }
            .predefined-reason-btn {
              transition: all 0.2s ease;
            }
           
          `}
          </style>
          <Card className="border-theme">
            <CardBody className={"p-0-mobile"}>
              <div className="mb-4 h-full-mobile" style={{ overflowY: "auto" }}>
                <div className="card-body">
                  {messages.map((msg, index) => (
                    <div
                      key={index}
                      className={`d-flex w-100 mb-4 ${
                        msg.role == "user" ? "justify-content-end" : ""
                      }`}
                    >
                      <div
                        className={`message-box ${
                          msg.role === "user"
                            ? "user-message"
                            : "assistant-message"
                        } ${index == messages.length - 1 ? "fade-in" : ""}`}
                      >
                        <SafeHtml text={msg?.message} />

                        {/* Timestamp and Feedback Buttons */}
                        <div className="mt-2 d-flex justify-content-between align-items-center">
                          {msg.createdAt && (
                            <small className="text-muted opacity-50">
                              {formatDateTime(msg.createdAt)}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                  {waitingReply && (
                    <div>
                      <div className="spinner-grow text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="input-group mb-1">
                <div className="d-flex w-100 mt-1">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Type a message..."
                    disabled={loading || waitingReply}
                  />
                  <div style={{ marginLeft: "auto" }}>
                    <button
                      className="btn btn-theme text-black px-4"
                      style={{
                        width: "115px",
                        marginLeft: "10px",
                        height: "40px",
                      }}
                      type="button"
                      onClick={() => sendMessage()}
                      disabled={loading || waitingReply}
                    >
                      <i className="fas fa-paper-plane me-2"></i>
                      Send
                    </button>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default AssetList;
